import { LEVEL_FAILED } from '../actionTypes';
import { turnSelectors, financialStatementsSelectors, financialStatementsActions } from '~/store';

function levelFailed() {
	return (dispatch, getState) => {
		const state = getState();
		const currentQuarterNum = turnSelectors.getCurrentQuarterNum(state);
		const quarterToFill = currentQuarterNum - 1;
		const systemFinancialStatements = financialStatementsSelectors.getSystemFinancialStatementsFor(state, quarterToFill);

		if (systemFinancialStatements && Object.keys(systemFinancialStatements).length > 0 && quarterToFill > 0) {
			dispatch(financialStatementsActions.fillUserFinancialStatementsWithSystemStatements(
				quarterToFill,
				systemFinancialStatements,
				true
			));
		}

		dispatch({ type: LEVEL_FAILED });
	};
}

export default levelFailed;
